import DataMapper from './DataMapper'
import LeaveRequest from '../../models/LeaveRequest'
import LeaveRequestRM from '../responsemodel/LeaveReruestRM'

export default class LeaveRequestDataMapper extends DataMapper<LeaveRequestRM, LeaveRequest> {
  map = (rm: LeaveRequestRM) => { return new LeaveRequest(rm.id, rm.session, rm.startDate, rm.endDate, rm.status, rm.reason, rm.rejectedReason, rm.appliedBy) }
}
